module.exports = __webpack_public_path__ + "media/images/menu_icon-355cf5a5ce47f031ebcf7e6f37b1f885.png";